import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const STATEMENT_LINKS_SCHEMA = Object.freeze({
  STATEMENT_URL: '',
  PORTAL_URL: '',
});
const RECORD = generateSchema(STATEMENT_LINKS_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_LINKS_SCHEMA);

export class StatementLinks extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get statementUrl(): string {
    return this.get(KEYS.STATEMENT_URL);
  }
}
